<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info">
      Health, Safety, and Environmental Management </span
    >
  </div>

  <div class="container p-5 !pt-0 !pb-0">
    <div #container_wrapper id="container_wrapper" class="container_wrapper">
      <ng-container>
        <div
          class="container-fluid flex justify-center h-auto !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
        >
          <div class="!pb-0 !bg-[#ffffff] w-full !pt-[0px]">
            <h3
              class="!text-[20px] font-semibold !pl-[17px] !mb-[0px] !pt-0 !pb-[22px]"
            >
              Health and Safety Policy
            </h3>
            <div
              class="grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div
                    class="long-section !p-10 !pb-0 !pt-0 flex items-center !w-full !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                  >
                    <label>
                      Do you have a Health and Safety Policy in place?
                    </label>
                    <mat-radio-group
                      formControlName="has_health_policy"
                      aria-label="Health and Safety Policy"
                      class="flex gap-4"
                    >
                      <mat-radio-button value="1">Yes</mat-radio-button>
                      <mat-radio-button value="0">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <app-file-manager
                [IsDragNDrop]="true"
                [label]="'Please provide health and safety policy documents'"
                [newFileControlName]="'healthAndSafetyPolicyFileControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldHealthAndSafetyPolicyFiles"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>

              <div class="!mt-[6px] !mb-[19px] container p-5 !pt-0 !pb-0">
                <div class="rounded !pb-0 !pt-0">
                  <div
                    class="long-section !p-10 !pb-0 !pt-0 flex items-center !w-full !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                  >
                    <label>
                      Have you had any reportable incidents (e.g., RIDDOR) in
                      the past three years? If yes, please provide details.
                    </label>
                    <mat-radio-group
                      formControlName="health_incidents"
                      aria-label="Health and Safety Policy"
                      class="flex gap-4"
                    >
                      <mat-radio-button value="1">Yes</mat-radio-button>
                      <mat-radio-button value="0">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>

              <div
                class="container p-5 !pt-0 !pb-0 !mt-[29px]"
                *ngIf="formGroup.get('health_incidents').value === '1'"
              >
                <div class="rounded !pb-0 !pt-0">
                  <mat-form-field
                    class="!w-full !h-[127px] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Provide Detail </mat-label>
                    <textarea
                      matInput
                      formControlName="health_incident_details"
                      placeholder="Provide Detail"
                      rows="4"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <h3
              class="!text-[20px] font-semibold !pl-[17px] !mb-[0px] !pt-[12px] !pb-[18px]"
            >
              Safety Accreditation
            </h3>
            <div
              class="grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <app-file-manager
                [IsDragNDrop]="true"
                [label]="
                  'Please provide evidence of any Health and Safety accreditations (e.g., CHAS, Safe Contractor)'
                "
                [newFileControlName]="'safetyAccreditationsFileControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldSafetyAccreditationsFiles"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>

            <h3
              class="!text-[20px] font-semibold !pl-[17px] !mb-[0px] !pt-[29px] !pb-[18px]"
            >
              Environmental Policy
            </h3>
            <div
              class="grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !mb-[41px]"
            >
              <div>
                <div class="!mt-[6px] container p-5 !pt-0 !pb-0 !mb-4">
                  <div class="rounded !pb-0 !pt-0">
                    <div
                      class="long-section !p-10 !pb-0 !pt-0 flex items-center !w-full !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                    >
                      <label>
                        Do you have an Environmental Management Policy in place?
                      </label>
                      <mat-radio-group
                        formControlName="has_env_policy"
                        aria-label="Health and Safety Policy"
                        class="flex gap-4"
                      >
                        <mat-radio-button value="1">Yes</mat-radio-button>
                        <mat-radio-button value="0">No</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
                <app-file-manager
                  [IsDragNDrop]="true"
                  [label]="'Please provide environmental policy documents'"
                  [newFileControlName]="'environmentalPolicyFileControl'"
                  (newFilesUpdatedEvent)="handleNewFiles($event)"
                  [oldFiles]="oldEnvironmentalPolicyFiles"
                  (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
                ></app-file-manager>
              </div>

              <app-file-manager
                [IsDragNDrop]="true"
                [label]="
                  'Provide details of any environmental accreditations (e.g., ISO 14001)'
                "
                [newFileControlName]="'environmentalAccreditationsFileControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldEnvironmentalAccreditationsFiles"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>

              <div class="container p-5 !pt-0 !pb-0 !mt-[29px]">
                <div class="rounded !pb-0 !pt-0">
                  <mat-form-field
                    class="!w-[100%] !h-[127px] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label>
                      Describe any sustainability initiatives your company is
                      involved in
                    </mat-label>
                    <textarea
                      matInput
                      formControlName="sustainability_initiatives"
                      placeholder="Describe any sustainability initiatives your company is involved in"
                      rows="4"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
              <app-file-manager
                [IsDragNDrop]="true"
                [label]="'Sustainability Initiatives Attachments'"
                [newFileControlName]="'sustainabilityFileControl'"
                (newFilesUpdatedEvent)="handleNewFiles($event)"
                [oldFiles]="oldSustainabilityFiles"
                (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
              ></app-file-manager>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</form>
